const lmIsEmail = ( value: string ): boolean => {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test( value );
}
export default lmIsEmail;